/**
 * Call Page
 * Thin connector that wires up the ViewModel to the View
 */

import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { CallView, useCallViewModel } from "../features/call";
import type { Contact } from "../api/types";
import { Routes } from "../routes";

export function CallPage() {
  const location = useLocation();
  const navigate = useNavigate();

  // Get contact from navigation state
  const contact = location.state?.contact as Contact | undefined;

  // Redirect if no contact
  useEffect(() => {
    if (!contact) {
      navigate(Routes.HOME);
    }
  }, [contact, navigate]);

  const viewModel = useCallViewModel({
    contact: contact || null,
    onCallEnded: () => {
      // Could add analytics or cleanup here
    },
  });

  if (!contact) {
    return null;
  }

  return <CallView viewModel={viewModel} />;
}
